import React from 'react'
import { I18n } from '@front/volcanion/'
import { isRequired } from '@front/squirtle/utils/validators'


import { Typography, Grid, Box, StepLabel, StepContent } from '@mui/material'
import { TextField, DateField, MenuSelectorField, SingleOptionSelectorField, ModelMenuSelectorField } from '@front/squirtle/'

import CPUtils from '@front/squirtle/utils/CPUtils'

const Row1 = ({ isManagingRecord }) =>
  <Grid container spacing={1} size={12}>
    <Grid size="grow">
      <TextField name={'client_id'} label={I18n.t('companyservice.code')} validate={isRequired} required />
    </Grid>
    <Grid size="grow">
      <TextField name={'name'} label={I18n.t('name.label', { count: 1 })} validate={isRequired} required />
    </Grid>
    <Grid size="grow">
      <TextField name={'contact.email'} label={I18n.t('email.label', { count: 1 })} validate={isRequired} required />
    </Grid>
    <Grid size="grow">
      <TextField name={'contact.gsm'} label={I18n.t('phone.label', { count: 1 })} />
    </Grid>
    <Grid size="grow">
      <MenuSelectorField
        label={I18n.t('status.label', { count: 1 })}
        name={'status'}
        options={_.compact([
          { label: <Box color='green' fontWeight={500}> {I18n.t('status.active')}  </Box>, value: 'active' },
          { label: <Box color='orange' fontWeight={500}> {I18n.t('status.inactive')}  </Box>, value: 'inactive' },
          !!isManagingRecord && { label: <Box color='red' fontWeight={500}> {I18n.t('status.archive')}  </Box>, value: 'archive' },
        ])}
        selectFirst
        required
      />
    </Grid>
  </Grid>

const Row2 = props =>
  <Grid container spacing={1} size={12}>
    <Grid size="grow">
      <DateField
        name={'availableSince'}
        label={I18n.t('companyservice.available.since')}
        inputFormat={'DD/MM/YYYY'}
        mask={'__/__/____'}
        validate={isRequired}
        required
      />
    </Grid>
    <Grid size="grow">
      <DateField
        name={'availableUntil'}
        label={I18n.t('companyservice.available.until')}
        inputFormat={'DD/MM/YYYY'}
        mask={'__/__/____'}
        disablePast
      />
    </Grid>
    <Grid size={5}>
      <TextField
        name={'comments.information'}
        label={I18n.t('info.label', { count: 1 })}
        alwaysInclude
      />
    </Grid>
    <Grid size="grow">
      <SingleOptionSelectorField
        name={'exclude_heatmap'}
        label={I18n.t('heatmap.exclude_heatmap')}
        clearOnEmpty={false}
      />
    </Grid>
    <Grid size="grow">
      <SingleOptionSelectorField
        name={'bypass_heatmap_cascade'}
        label={I18n.t('heatmap.bypass_heatmap_cascade')}
        clearOnEmpty={false}
      />
    </Grid>
  </Grid>

const Row3 = props =>
  <Grid container spacing={1} size={12}>
    <Grid size="grow">
      <SingleOptionSelectorField
        name='hide_driverinfo'
        label={I18n.t('hide_driverinfo')}
        clearOnEmpty={false}
      />
    </Grid>
    <Grid size="grow">
      <SingleOptionSelectorField
        name='priority'
        label={I18n.t('priority.label.order')}
        clearOnEmpty={false}
      />
    </Grid>
  </Grid>

const Row4 = () =>
  <Grid container size={12} spacing={1}>
    <Grid size="grow">
      <ModelMenuSelectorField
        name='excluded_commercial_packages'
        model_name='commercialpackage'
        label={I18n.t('commercialpackage.label.exclude')}
        searchMode='search'
        multiple
        config={{
          initial_filter: {},
          mutator: cp => ({ ...CPUtils.getTranslatedLabel(cp), ...cp })
        }}
      />
    </Grid>
  </Grid>

const PrimarySection = props => <>
  <StepLabel>
    <Typography variant='h5'> {I18n.t('info.general')}</Typography>
  </StepLabel>
  <StepContent >
    <Box sx={{ p: 3, boxShadow: 6, borderRadius: 1 }}>
      <Grid container rowSpacing={2}>
        <Row1 {...props} />
        <Row2 />
        <Row3 />
        <Row4 />
      </Grid>
    </Box>
  </StepContent>
</>

export default React.memo(PrimarySection)
